import Seo from "@/components/Seo";
import { StartAbschluss, PreisModell } from "@/components/Startseite";
import { Beispiele } from "@/components/StartseiteRuhig";
import { HeroNeu, SoGehts, TicketsEvents } from "@/components/StartseiteNeu";
import { DemoShowcase } from "@/components/DemoShowcase";
import { KreislaufPrinzip } from "@/components/KreislaufPrinzip";
import { ZahlenUndStimmen } from "@/components/Vertrauen";
import { ScrollNav } from "@/components/ScrollNav";
import { BrancheProvider } from "@/components/BrancheContext";
import { StickyTestCta } from "@/components/StickyTestCta";
import { Faq } from "@/components/Faq";
import { FAQ } from "@/data/faq";
import { graph, organization, person, website, webPage, faqPage } from "@/seo/schema";

/* Startseite (Etappe 1, Thomas): 8 Abschnitte in fester Reihenfolge.
   1 Hero → 2 So geht's → 3 Prinzip „Sehen. Kommen. Wiederkommen.“ → 4 Alltag/Branchen (Beispiele)
   → 5 Zahlen & Stimmen → 6 Preise (gleiche Datenquelle wie /preise) → 7 FAQ (6 Fragen) → 8 Abschluss.
   Entfernt von der Startseite (Seiten bleiben erreichbar): DasKannRobbie, BranchenWeiche, LeistungenBlock, PreisBalken. */
const HOME_FAQ = [FAQ[0], FAQ[2], FAQ[3], FAQ[4], FAQ[5], FAQ[7]];

const Home = () => (
  <>
    <Seo
      title="DIMEDIAL – Robbie, dein digitaler Mitarbeiter für Sichtbarkeit"
      description="Robbie ist dein digitaler Mitarbeiter für Sichtbarkeit – per WhatsApp. Foto schicken, freigeben: Beitrag, Google-Meldung, Bildschirm und Website sind aktuell. Für Gastronomie, Handel und Vereine. Ab 59 € netto/Monat, 30 Tage kostenlos testen."
      path="/"
      jsonLd={graph(website(), organization(), person(), webPage("/", "DIMEDIAL – Robbie, dein digitaler Mitarbeiter für Sichtbarkeit", "Robbie ist dein digitaler Mitarbeiter für Sichtbarkeit – per WhatsApp. Foto schicken, freigeben: Beitrag, Google-Meldung, Bildschirm und Website sind aktuell. Für Gastronomie, Handel und Vereine."), faqPage(HOME_FAQ))}
    />
    <BrancheProvider>
      <HeroNeu />
      <SoGehts />
      <TicketsEvents />
      <KreislaufPrinzip />
      <Beispiele />
      <div className="mx-auto max-w-6xl px-4 py-12 sm:py-16"><DemoShowcase variant="full" source="startseite" /></div>
      <ZahlenUndStimmen />
      <PreisModell />
      <Faq items={HOME_FAQ} />
      <StartAbschluss />
    </BrancheProvider>
    <ScrollNav />
    <StickyTestCta />
  </>
);

export default Home;
